module.exports = __webpack_public_path__ + "img/13.1f440eb5.png";